<i18n>
{
  "en": {
    "specialRequests": "Special requests",
    "done": "Done"
  },
  "zh-tw": {
    "specialRequests": "備註",
    "done": "完成"
  }
}
</i18n>

<template>
  <f7-popup
    :color-theme="themeColor"
    style="overflow-y: auto;">
    <div
      style="float: right; margin: 10px;"
      @click="$f7.popup.close()">
      <font-awesome-icon icon="times" />
    </div>
    <f7-list
      no-hairlines-md
      no-hairlines-between-md
      style="padding: 20px;">
      <f7-list-item>{{ $t(`specialRequests`) }}</f7-list-item>
      <f7-list-item>
        <f7-input
          type="textarea"
          resizable
          placeholder="ex. 不須加蔥"
          :default-value="itemObj.specialRequests"
          @input="specialRequests = $event.target.value">
        </f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-button
          fill
          raised
          style="margin: 20px;"
          @click="done()">
          {{ $t(`done`) }}
        </f7-button>
      </f7-list-item>
    </f7-list>
  </f7-popup>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SpecialRequestsPopup',
  dependencies: ['themeColor'],
  data () {
    return {
      itemDefinitionId: this.fullItemIdPathParam.split('.')[0],
      itemInstanceId: this.fullItemIdPathParam.split('.')[1],
      specialRequests: ''
    }
  },
  props: {
    itemBucketPathParam: String,
    fullItemIdPathParam: String,
    questionIdPathParam: String
  },
  computed: {
    ...mapState('itemModule', [
      'cart',
      'favorites'
    ]),
    itemObj () {
      return this[this.itemBucketPathParam][this.itemDefinitionId][this.itemInstanceId]
    }
  },
  methods: {
    done () {
      this.setSpecialRequests({
        itemBucket: this.itemBucketPathParam,
        itemId: this.itemDefinitionId,
        itemInstanceId: this.itemInstanceId,
        value: this.specialRequests
      })
      this.$f7.popup.close()
    },
    ...mapActions('itemModule', ['setSpecialRequests'])
  }
}
</script>
